import api from '../../api';

const BASE_URL = '/plugging-design/project';

// PROJECT CRUD
// =================================================

export const fetchProjectList = async (owner) => {
  const response = await api.get(`${BASE_URL}?owner=${owner}`);
  return response.data;
};

export const readProject = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}`);
  return response.data;
};

export const updateProject = async (projectId, project) => {
  const response = await api.put(`${BASE_URL}/${projectId}`, project);
  return response.data;
};

export const addProject = async (project) => {
  const response = await api.post(`${BASE_URL}`, project);
  return response.data;
};

export const duplicateProject = async (project) => {
  const response = await api.post(`${BASE_URL}`, project);
  return response.data;
};

export const removeProject = async (projectId) => {
  const response = await api.delete(`${BASE_URL}/${projectId}`);
  return response.data;
};

export const permanentDeleteProjects = async () => {
  const response = await api.delete(`${BASE_URL}`);
  return response.data;
};

export const createDemoProject = async (payload) => {
  const response = await api.post(`${BASE_URL}/demo`, payload);
  return response.data;
};

export const cleanupDatabase = async (payload) => {
  const response = await api.delete(`${BASE_URL}/demo/cleanup-db`, { data: payload });
  return response.data;
};

// PROJECT CONTROLLER
// =================================================

export const updatePluggingDesign = async (projectId) => {
  const response = await api.post(`${BASE_URL}/${projectId}/run-program`);
  return response.data;
};

export const applyPluggingDesign = async (projectId) => {
  const response = await api.post(`${BASE_URL}/${projectId}/apply-plug-program`);
  return response.data;
};

export const runAutoPlugDesign = async (projectId) => {
  const response = await api.post(`${BASE_URL}/${projectId}/run-auto-plug-design`);
  return response.data;
};

export const deletePluggingDesign = async (projectId) => {
  const response = await api.delete(`${BASE_URL}/${projectId}/delete-outputs`);
  return response.data;
};

// PROJECT INPUT GENERAL
// =================================================

export const readInputGeneral = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/input-general`);
  return response.data;
};

export const updateInputGeneral = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/input-general`, obj);
  return response.data;
};

// PROJECT INPUT PRESSURE
// =================================================

export const readInputPressure = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/input-pressure`);
  return response.data;
};

export const updateInputPressure = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/input-pressure`, obj);
  return response.data;
};

// PROJECT INPUT CASING PROGRAM
// =================================================

export const readInputCasingProgram = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/input-casing-program`);
  return response.data;
};

export const updateInputCasingProgram = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/input-casing-program`, obj);
  return response.data;
};

// PROJECT INPUT PLUG PROGRAM
// =================================================

export const readInputPlugProgram = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/input-plug-program`);
  return response.data;
};

export const updateInputPlugProgram = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/input-plug-program`, obj);
  return response.data;
};

// PROJECT INPUT ZONE PROGRAM
// =================================================

export const readInputZoneProgram = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/input-zone-program`);
  return response.data;
};

export const updateInputZoneProgram = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/input-zone-program`, obj);
  return response.data;
};

// PROJECT OUTPUT SUMMARY
// =================================================

export const readOutputSummary = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/output-summary`);
  return response.data;
};

export const updateOutputSummary = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/output-summary`, obj);
  return response.data;
};

// PROJECT OUTPUT DETAIL
// =================================================

export const readOutputDetail = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/output-detail`);
  return response.data;
};

export const updateOutputDetail = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/output-detail`, obj);
  return response.data;
};

// PROJECT OUTPUT TIME SERIES
// =================================================

export const readOutputTimeSeries = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/output-time-series`);
  return response.data;
};

export const updateOutputTimeSeries = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/output-time-series`, obj);
  return response.data;
};

// PROJECT OUTPUT SPACE
// =================================================

export const readOutputSpace = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/output-space`);
  return response.data;
};

export const updateOutputSpace = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/output-space`, obj);
  return response.data;
};

// PROJECT OUTPUT PLUG PROGRAM
// =================================================

export const readOutputPlugProgram = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/output-plug-program`);
  return response.data;
};

export const updateOutputPlugProgram = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/output-plug-program`, obj);
  return response.data;
};
